import { ChatInfoContext } from "hhn-commons";
import { useContext } from "react";
import { useOutsideClick } from "../utils/UseOutsideClick";
import { ChatInfoWrapper } from "./ChatInfo.style";
import ChatInfoContent from "./ChatInfoContent";

export const ChatInfo = ({ tabValue }: { tabValue?: number }) => {
  const { chat } = useContext(ChatInfoContext);
  const info = chat ? chat.chatInfo : undefined;

  return (
    <ChatInfoWrapper ref={useOutsideClick()} data-testid="chat-info-component">
      {info && <ChatInfoContent info={info} tabValue={tabValue} />}
    </ChatInfoWrapper>
  );
};
